import { render } from "./ReferencesPage.vue?vue&type=template&id=6b78bc1f&ts=true"
import script from "./ReferencesPage.vue?vue&type=script&lang=ts"
export * from "./ReferencesPage.vue?vue&type=script&lang=ts"

import "./ReferencesPage.vue?vue&type=style&index=0&id=6b78bc1f&lang=less"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__